import Dashboard from "../pages/dashboard.vue"
import Login from "../pages/login.vue"
import { ANALYTICS_DASHBOARD_ROUTES } from "../utils/analytics-dashboard-goals"

// new routes
const NoticeMaster = () => import(/* webpackChunkName: "masters" */ "../pages/notices/index.vue")
const NotificationMaster = () => import(/* webpackChunkName: "masters" */ "../pages/notifications/index.vue")
const Products = () => import(/* webpackChunkName: "products" */ "../pages/products/index.vue")
const BulkImportProducts = () => import(/* webpackChunkName: "products" */ "../pages/products/bulk-import.vue")
const BulkImportCustomers = () => import(/* webpackChunkName: "customers" */ "../pages/customers/bulk-import.vue")
const ProductCreate = () => import(/* webpackChunkName: "products" */ "../pages/products/create.vue")
const ProductDetail = () => import(/* webpackChunkName: "products" */ "../pages/products/detail.vue")
const Crew = () => import(/* webpackChunkName: "crew" */ "../pages/crew/index.vue")
const CrewRoles = () => import(/* webpackChunkName: "crew" */ "../pages/crew-roles/index.vue")
const Orders = () => import(/* webpackChunkName: "orders" */ "../pages/orders/index.vue")
const Customers = () => import(/* webpackChunkName: "customers" */ "../pages/customers/index.vue")
const Stock = () => import(/* webpackChunkName: "inventory" */ "../pages/stock/index.vue")
const StockLogs = () => import(/* webpackChunkName: "inventory" */ "../pages/stock/logs.vue")
const Reports = () => import(/* webpackChunkName: "reports" */ "../pages/reports/index.vue")
const Warehouse = () => import(/* webpackChunkName: "masters" */ "../pages/warehouse/index.vue")
const CustomerGroups = () => import(/* webpackChunkName: "customers" */ "../pages/customer-groups/index.vue")
const PosProfile = () => import(/* webpackChunkName: "masters" */ "../pages/pos-profile/index.vue")
const ItemGroup = () => import(/* webpackChunkName: "catalog" */ "../pages/catalog/item-groups/index.vue")
const Settings = () => import(/* webpackChunkName: "settings" */ "../pages/settings/index.vue")
const CustomerEdit = () => import(/* webpackChunkName: "customers" */ "../pages/customers/edit.vue")
const InventoryManager = () => import(/* webpackChunkName: "inventory" */ "../pages/inventory/inventory-manager.vue")
const StockImport = () => import(/* webpackChunkName: "inventory" */ "../pages/inventory/stock-import.vue")
const CovaSync = () => import(/* webpackChunkName: "inventory" */ "../pages/inventory/cova-sync.vue")
const CovaImportWizard = () => import(/* webpackChunkName: "inventory" */ "../pages/inventory/cova-import-wizard.vue")
const CovaReconciliation = () => import(/* webpackChunkName: "inventory" */ "../pages/inventory/cova-reconciliation.vue")
const ImportHistory = () => import(/* webpackChunkName: "inventory" */ "../pages/inventory/import-history.vue")
const ImportHistoryDetail = () => import(/* webpackChunkName: "inventory" */ "../pages/inventory/import-history-details.vue")
const AdjustmentQuantity = () => import(/* webpackChunkName: "inventory-adjustments" */ "../pages/inventory/adjustments/adjustment-quantity.vue")
const AdjustmentQuantityCreate = () => import(/* webpackChunkName: "inventory-adjustments" */ "../pages/inventory/adjustments/adjustment-quantity-create.vue")
const AdjustmentQuantityDetails = () => import(/* webpackChunkName: "inventory-adjustments" */ "../pages/inventory/adjustments/adjustment-quantity-details.vue")
const StockTransferList = () => import(/* webpackChunkName: "stock-transfers" */ "../pages/inventory/transfer/stock-transfer-list.vue")
const StockTransferDetails = () => import(/* webpackChunkName: "stock-transfers" */ "../pages/inventory/transfer/stock-transfer-details.vue")
const StockTransferCreate = () => import(/* webpackChunkName: "stock-transfers" */ "../pages/inventory/transfer/stock-transfer-create.vue")
const StockTransferReceive = () => import(/* webpackChunkName: "stock-transfers" */ "../pages/inventory/transfer/stock-transfer-receive.vue")
const TerpeneList = () => import(/* webpackChunkName: "catalog" */ "../pages/terpenes/index.vue")
const GLAccounts = () => import(/* webpackChunkName: "settings" */ "../pages/settings/gl-accounts/index.vue")
const GLDefaults = () => import(/* webpackChunkName: "settings" */ "../pages/settings/gl-defaults/index.vue")
const Suppliers = () => import(/* webpackChunkName: "masters" */ "../pages/suppliers/index.vue")
const ModeOfPayment = () => import(/* webpackChunkName: "settings" */ "../pages/mode-of-payment/index.vue")
const ModeOfPaymentEdit = () => import(/* webpackChunkName: "settings" */ "../pages/mode-of-payment/edit.vue")
const PaymentHardwareEdit = () => import(/* webpackChunkName: "settings" */ "../pages/mode-of-payment/payment_hardware_edit.vue")
const GovtIds = () => import(/* webpackChunkName: "settings" */ "../pages/govt-ids/index.vue")
const ReasonCode = () => import(/* webpackChunkName: "settings" */ "../pages/settings/reason-code.vue")
const RetainedFloatSettings = () => import(/* webpackChunkName: "settings" */ "../pages/settings/retained-float.vue")
const CheckoutPolicySettings = () => import(/* webpackChunkName: "settings" */ "../pages/settings/checkout-policy.vue")
const AccountAutomationSettings = () => import(/* webpackChunkName: "settings" */ "../pages/settings/account-automation.vue")
const EmailTemplates = () => import(/* webpackChunkName: "email-templates" */ "../pages/email-templates/index.vue")
const EmailTemplateEditor = () => import(/* webpackChunkName: "email-template-editor" */ "../pages/email-templates/editor.vue")
const EmailTemplateVersions = () => import(/* webpackChunkName: "email-template-versions" */ "../pages/email-templates/versions.vue")
const NewsletterSubscribers = () => import(/* webpackChunkName: "newsletter-subscribers" */ "../pages/newsletter-subscribers/index.vue")
const LoyaltyManagement = () => import(/* webpackChunkName: "loyalty" */ "../pages/settings/loyalty-management.vue")
const LoyaltySettings = () => import(/* webpackChunkName: "loyalty" */ "../pages/settings/loyalty.vue")
const LoyaltyRewards = () => import(/* webpackChunkName: "loyalty" */ "../pages/settings/loyalty-rewards.vue")
const LoyaltyCampaigns = () => import(/* webpackChunkName: "loyalty" */ "../pages/settings/loyalty-campaigns.vue")
const LoyaltyTiers = () => import(/* webpackChunkName: "loyalty" */ "../pages/settings/loyalty-tiers.vue")
const LoyaltyHealth = () => import(/* webpackChunkName: "loyalty" */ "../pages/settings/loyalty-health.vue")
const LoyaltyReconciliation = () => import(/* webpackChunkName: "loyalty" */ "../pages/settings/loyalty-reconciliation.vue")
const CustomerLoyaltyDetail = () => import(/* webpackChunkName: "loyalty" */ "../pages/customers/loyalty-detail.vue")
const MyProfile = () => import(/* webpackChunkName: "profile" */ "../pages/my-profile.vue")
const LocationLevelPricingEdit = () => import(/* webpackChunkName: "products" */ "../components/product/LocationLevelPricingEdit.vue")
const CashManagement = () => import(/* webpackChunkName: "cash-management" */ "../pages/cash-management/index.vue")
const SafeList = () => import(/* webpackChunkName: "cash-management" */ "../pages/cash-management/safe-list.vue")
const SafeDrawerDetail = () => import(/* webpackChunkName: "cash-management" */ "../pages/cash-management/safe-drawer-detail.vue")
const SafeDrawerOpenClose = () => import(/* webpackChunkName: "cash-management" */ "../pages/cash-management/safe-drawer-open-close.vue")
const SafeDrawerTransfer = () => import(/* webpackChunkName: "cash-management" */ "../pages/cash-management/safe-drawer-transfer.vue")
const SafeDrawerTransactionDetail = () => import(/* webpackChunkName: "cash-management" */ "../pages/cash-management/safe-drawer-transaction-detail.vue")
const InvoiceIndex = () => import(/* webpackChunkName: "invoices" */ "../pages/invoices/index.vue")
const InvoiceEdit = () => import(/* webpackChunkName: "invoices" */ "../pages/invoices/_edit.vue")
const AnalyticsProgramDashboard = () => import(/* webpackChunkName: "dashboards" */ "../pages/dashboards/AnalyticsProgramDashboard.vue")
const SalesDashboard = () => import(/* webpackChunkName: "dashboards" */ "../pages/sales/index.vue")
const FocusedDashboardPage = () => import(/* webpackChunkName: "dashboards" */ "../pages/dashboards/FocusedDashboardPage.vue")
const InventoryOperationsDashboard = () => import(/* webpackChunkName: "dashboards" */ "../pages/dashboards/InventoryOperationsDashboard.vue")
const ProductCategoryDashboard = () => import(/* webpackChunkName: "dashboards" */ "../pages/dashboards/ProductCategoryDashboard.vue")
const ComplianceDataQualityDashboard = () => import(/* webpackChunkName: "dashboards" */ "../pages/dashboards/ComplianceDataQualityDashboard.vue")
const CustomerLoyaltyDashboard = () => import(/* webpackChunkName: "dashboards" */ "../pages/dashboards/CustomerLoyaltyDashboard.vue")
const FinanceManagementDashboard = () => import(/* webpackChunkName: "dashboards" */ "../pages/dashboards/FinanceManagementDashboard.vue")
const PurchaseOrderIndex = () => import(/* webpackChunkName: "purchase-orders" */ "../pages/purchase-orders/index.vue")
const PurchaseOrderEdit = () => import(/* webpackChunkName: "purchase-orders" */ "../pages/purchase-orders/_edit.vue")
const PurchaseOrderReceive = () => import(/* webpackChunkName: "purchase-orders" */ "../pages/purchase-orders/receive.vue")
const CashManagementReport = () => import(/* webpackChunkName: "reports" */ "../components/reports/CashManagementReport.vue")
const CustomerReport = () => import(/* webpackChunkName: "reports" */ "../components/reports/CustomerReport.vue")
const InventoryAdjustmentReport = () => import(/* webpackChunkName: "reports-inventory" */ "../components/reports/inventory/InventoryAdjustmentReport.vue")
const InventoryTransferReport = () => import(/* webpackChunkName: "reports-inventory" */ "../components/reports/inventory/InventoryTransferReport.vue")
const InventoryTransactionReport = () => import(/* webpackChunkName: "reports-inventory" */ "../components/reports/inventory/InventoryTransactionReport.vue")
const InventoryOnHandReport = () => import(/* webpackChunkName: "reports-inventory" */ "../components/reports/inventory/InventoryOnHandReport.vue")
const PurchaseOrderReport = () => import(/* webpackChunkName: "reports-inventory" */ "../components/reports/inventory/PurchaseOrderReport.vue")
const RoomMovementReport = () => import(/* webpackChunkName: "reports-inventory" */ "../components/reports/inventory/RoomMovementReport.vue")
const InventoryLastReceivedReport = () => import(/* webpackChunkName: "reports-inventory" */ "../components/reports/inventory/InventoryLastReceivedReport.vue")
const SalesReport = () => import(/* webpackChunkName: "reports-sales" */ "../components/reports/sales/SalesReport.vue")
const SalesReportByClassification = () => import(/* webpackChunkName: "reports-sales" */ "../components/reports/sales/SalesReportByClassification.vue")
const SalesReportByLocation = () => import(/* webpackChunkName: "reports-sales" */ "../components/reports/sales/SalesReportByLocation.vue")
const SalesReportByProduct = () => import(/* webpackChunkName: "reports-sales" */ "../components/reports/sales/SalesReportByProduct.vue")
const SalesReportByEmployee = () => import(/* webpackChunkName: "reports-sales" */ "../components/reports/sales/SalesReportByEmployee.vue")
const SalesReportEndOfDay = () => import(/* webpackChunkName: "reports-sales" */ "../components/reports/sales/SalesReportEndOfDay.vue")
const GLAccountTransactionReport = () => import(/* webpackChunkName: "reports-gl" */ "../components/reports/gl-account/GLAccountTransactionReport.vue")
const GLAccountTotalReport = () => import(/* webpackChunkName: "reports-gl" */ "../components/reports/gl-account/GLAccountTotalReport.vue")
const DiscountReport = () => import(/* webpackChunkName: "reports-sales" */ "../components/reports/sales/DiscountReport.vue")
const SkippingReport = () => import(/* webpackChunkName: "reports-sales" */ "../components/reports/sales/SkippingReport.vue")
const DrawerActionReport = () => import(/* webpackChunkName: "reports-sales" */ "../components/reports/sales/DrawerActionReport.vue")
const AgcoReporting = () => import(/* webpackChunkName: "settings" */ "../pages/settings/agco-reporting/index.vue")
const Promotion = () => import(/* webpackChunkName: "promotions" */ "../pages/promotions/index.vue")
const PromotionEdit = () => import(/* webpackChunkName: "promotions" */ "../pages/promotions/edit.vue")
const PrintLabelPage = () => import(/* webpackChunkName: "catalog" */ "../pages/catalog/print-labels.vue")
const AgcoLogPage = () => import(/* webpackChunkName: "agco" */ "../pages/agco-logs/AgcoLog.vue")
const AgcoLogWarehousePage = () => import(/* webpackChunkName: "agco" */ "../pages/agco-logs/AgcoLogWarehouse.vue")
const ReconciliationPage = () => import(/* webpackChunkName: "reconciliation" */ "../pages/reconciliation/ReconciliationPage.vue")
const ReconciliationCreatePage = () => import(/* webpackChunkName: "reconciliation" */ "../pages/reconciliation/ReconciliationCreatePage.vue")
const ReconciliationDetailPage = () => import(/* webpackChunkName: "reconciliation" */ "../pages/reconciliation/ReconciliationDetailPage.vue")
const InventoryCountsPage = () => import(/* webpackChunkName: "inventory-counts" */ "../pages/inventory-counts/InventoryCountsPage.vue")
const InventoryCountCreatePage = () => import(/* webpackChunkName: "inventory-counts" */ "../pages/inventory-counts/InventoryCountCreatePage.vue")
const InventoryCountDetailPage = () => import(/* webpackChunkName: "inventory-counts" */ "../pages/inventory-counts/InventoryCountDetailPage.vue")
const DevicePage = () => import(/* webpackChunkName: "settings" */ "../pages/settings/devices/index.vue")
const PosAppReleasesPage = () => import(/* webpackChunkName: "settings" */ "../pages/settings/pos-app-releases.vue")
const PermissionPage = () => import(/* webpackChunkName: "permissions" */ "../pages/permission/index.vue")
const PermissionEditor = () => import(/* webpackChunkName: "permissions" */ "../pages/permission/editor.vue")
const ScannerTest = () => import(/* webpackChunkName: "scanner" */ "../pages/scanner-test.vue")

const routes = [
    { path: "/", component: Login, redirect: "/dashboard" },
    { path: "/login", component: Login },
    { path: "/dashboard", component: Dashboard },
    { path: ANALYTICS_DASHBOARD_ROUTES.PROGRAM, component: AnalyticsProgramDashboard, name: "dashboard-analytics-program" },
    { path: ANALYTICS_DASHBOARD_ROUTES.SALES_REVENUE, component: SalesDashboard, name: "dashboard-sales-revenue" },
    {
        path: ANALYTICS_DASHBOARD_ROUTES.INVENTORY_OPERATIONS,
        component: InventoryOperationsDashboard,
        name: "dashboard-inventory-operations",
    },
    {
        path: ANALYTICS_DASHBOARD_ROUTES.PRODUCT_CATEGORY,
        component: ProductCategoryDashboard,
        name: "dashboard-product-category",
    },
    {
        path: ANALYTICS_DASHBOARD_ROUTES.COMPLIANCE_DATA_QUALITY,
        component: ComplianceDataQualityDashboard,
        name: "dashboard-compliance-data-quality",
    },
    {
        path: ANALYTICS_DASHBOARD_ROUTES.CUSTOMER_LOYALTY,
        component: CustomerLoyaltyDashboard,
        name: "dashboard-customer-loyalty",
    },
    {
        path: ANALYTICS_DASHBOARD_ROUTES.ECOMMERCE,
        component: FocusedDashboardPage,
        name: "dashboard-ecommerce",
        props: { goalId: "ecommerce" },
    },
    {
        path: ANALYTICS_DASHBOARD_ROUTES.FINANCE_MANAGEMENT,
        component: FinanceManagementDashboard,
        name: "dashboard-finance-management",
    },
    { path: "/my-profile", component: MyProfile },

    // new routes
    { path: "/agco-reporting", component: AgcoReporting },
    { path: "/notifications", component: NotificationMaster },
    { path: "/notices", component: NoticeMaster },
    { path: "/products/bulk-import", component: BulkImportProducts },
    { path: "/products", component: Products },
    { path: "/products/create", component: ProductCreate },
    { path: "/products/pricing/:id", component: LocationLevelPricingEdit },
    { path: "/products/:id", component: ProductDetail },
    { path: "/item-groups", component: ItemGroup },
    { path: "/crew", component: Crew },
    { path: "/crew-roles", component: CrewRoles },
    { path: "/warehouses", component: Warehouse },
    { path: "/pos-profiles", component: PosProfile },
    { path: "/orders", component: Orders },
    { path: "/customers", component: Customers, name: "customers" },
    { path: "/customer-import", component: BulkImportCustomers },
    { path: "/customer-create", component: CustomerEdit },
    { path: "/customer-edit/:id", component: CustomerEdit, name: "customer-edit" },
    { path: "/customer-groups", component: CustomerGroups },
    { path: "/stock", component: Stock },
    { path: "/suppliers", component: Suppliers },
    { path: "/terpenes", component: TerpeneList },
    { path: "/print-labels", component: PrintLabelPage },

    // inventory management
    { path: "/inventory-manager", component: InventoryManager },

    // inventory adjustments

    { path: "/inventory-adjustments", redirect: "/inventory-adjustments/quantity" },
    { path: "/inventory-adjustments/quantity", component: AdjustmentQuantity },
    { path: "/inventory-adjustments/quantity/create", component: AdjustmentQuantityCreate },
    { path: "/inventory-adjustments/quantity/:id", component: AdjustmentQuantityDetails },
    { path: "/inventory-adjustments/price", component: () => import('../pages/inventory/adjustments/adjustment-price.vue') },
    { path: "/inventory-adjustments/price/create", component: () => import('../pages/inventory/adjustments/adjustment-price-create.vue') },
    { path: "/inventory-adjustments/price/:id", component: () => import('../pages/inventory/adjustments/adjustment-price-details.vue') },
    { path: "/inventory-adjustments/cost", component: () => import('../pages/inventory/adjustments/adjustment-cost.vue') },
    { path: "/inventory-adjustments/cost/:id", component: () => import('../pages/inventory/adjustments/adjustment-cost-details.vue') },

    { path: "/stock-logs", component: StockLogs },
    {
        path: "/stock-import",
        component: StockImport,
        beforeEnter: (to, from, next) => {
            if (to.query.active_tab === "COVA") {
                next("/cova-import")
                return
            }
            next()
        },
    },
    { path: "/cova-import", component: CovaSync },
    { path: "/cova-import/advanced", component: CovaImportWizard },
    { path: "/cova-reconciliation", redirect: "/cova-import" },
    { path: "/cova-reconciliation/advanced", component: CovaReconciliation },
    { path: "/import-history", component: ImportHistory },
    { path: "/import-history/:id", component: ImportHistoryDetail },
    { path: "/stock-transfers", component: StockTransferList },
    { path: "/stock-transfers/new", component: StockTransferCreate },
    { path: "/stock-transfers/:id", component: StockTransferDetails },
    { path: "/stock-transfers/:id/receive", component: StockTransferReceive },

    // Under Settings Section.
    { path: "/settings", component: Settings, name: "Settings" },
    { path: "/gl-accounts", component: GLAccounts, name: "GLAccontsListing" },
    { path: "/mode-of-payments", component: ModeOfPayment, name: "ModeOfPayment" },
    {
        path: "/mode-of-payments-create",
        component: ModeOfPaymentEdit,
        name: "mode-of-payment-create",
    },
    {
        path: "/mode-of-payments-edit/:id",
        component: ModeOfPaymentEdit,
        name: "mode-of-payment-edit",
    },
    {
        path: "/payment-hardware-create",
        component: PaymentHardwareEdit,
        name: "payment-hardware-create",
    },
    {
        path: "/payment-hardware-edit/:id",
        component: PaymentHardwareEdit,
        name: "payment-hardware-edit",
    },
    { path: "/govt-ids", component: GovtIds, name: "GovtId" },
    { path: "/gl-defaults", component: GLDefaults, name: "GLDefaultsListing" },
    // {
    //     path: "/gl-accounts/:id/:mode",
    //     component: GLAccountsAction,
    //     name: "GLAccountsAction",
    // },
    {
        path: "/reason-codes",
        component: ReasonCode,
        name: "ReasonCode",
    },
    {
        path: "/settings/retained-float",
        component: RetainedFloatSettings,
        name: "RetainedFloatSettings",
    },
    {
        path: "/settings/checkout-policy",
        component: CheckoutPolicySettings,
        name: "CheckoutPolicySettings",
    },
    {
        path: "/settings/account-automation",
        component: AccountAutomationSettings,
        name: "AccountAutomationSettings",
    },
    {
        path: "/settings/email-templates",
        component: EmailTemplates,
        name: "EmailTemplates",
    },
    {
        path: "/settings/email-templates/:templateKey",
        component: EmailTemplateEditor,
        name: "EmailTemplateEditor",
    },
    {
        path: "/settings/email-templates/:templateKey/versions",
        component: EmailTemplateVersions,
        name: "EmailTemplateVersions",
    },
    {
        path: "/settings/newsletter-subscribers",
        component: NewsletterSubscribers,
        name: "NewsletterSubscribers",
    },
    {
        path: "/settings/loyalty-management",
        component: LoyaltyManagement,
        name: "LoyaltyManagement",
    },
    {
        path: "/settings/loyalty",
        component: LoyaltySettings,
        name: "LoyaltySettings",
    },
    {
        path: "/settings/loyalty-rewards",
        component: LoyaltyRewards,
        name: "LoyaltyRewards",
    },
    {
        path: "/settings/loyalty-campaigns",
        component: LoyaltyCampaigns,
        name: "LoyaltyCampaigns",
    },
    {
        path: "/settings/loyalty-tiers",
        component: LoyaltyTiers,
        name: "LoyaltyTiers",
    },
    {
        path: "/settings/loyalty-health",
        component: LoyaltyHealth,
        name: "LoyaltyHealth",
    },
    {
        path: "/settings/loyalty-reconciliation",
        component: LoyaltyReconciliation,
        name: "LoyaltyReconciliation",
    },
    {
        path: "/customer-loyalty/:id",
        component: CustomerLoyaltyDetail,
        name: "customer-loyalty",
    },
    {
        path: "/promotions",
        component: Promotion,
        name: "promotions",
    },
    {
        path: "/promotions/create",
        component: PromotionEdit,
        name: "promotion_create",
    },
    {
        path: "/promotions/create/product-discount",
        component: PromotionEdit,
        name: "promotion_create_product_discount",
        meta: { promotionType: "product_discount" },
    },
    {
        path: "/promotions/create/bogo",
        component: PromotionEdit,
        name: "promotion_create_bogo",
        meta: { promotionType: "bogo_discounted" },
    },
    {
        path: "/promotions/create/bundle",
        component: PromotionEdit,
        name: "promotion_create_bundle",
        meta: { promotionType: "bundle_discount" },
    },
    {
        path: "/promotions/:id",
        component: PromotionEdit,
        name: "promotion_edit",
    },
    /**
     * CASH MANAGEMENT
     */

    { path: "/cash-management", component: CashManagement },
    { path: "/cash-management/:id", component: SafeList },
    { path: "/safe-drawers/:id", component: SafeDrawerDetail },
    { path: "/safe-drawers/:id/transfer", component: SafeDrawerTransfer },
    { path: "/safe-drawers/:id/:mode", component: SafeDrawerOpenClose },
    { path: "/safe-drawer-transactions/:id", component: SafeDrawerTransactionDetail },

    /**
     * SALES & INVOICES
     */

    { path: "/sales", redirect: ANALYTICS_DASHBOARD_ROUTES.SALES_REVENUE, name: "sales-dashboard" },
    { path: "/invoices", component: InvoiceIndex },
    { path: "/invoices/:id", component: InvoiceEdit, name: "invoice-edit" },

    /**
     * PURCHASE ORDERS
     */

    { path: "/purchase-orders", component: PurchaseOrderIndex },
    { path: "/purchase-orders/:id", component: PurchaseOrderEdit, name: "purchase-order-edit" },
    { path: "/purchase-orders/:id/receive", component: PurchaseOrderReceive, name: "purchase-order-receive" },

    /**
     * REPORTS
     */
    {
        path: "/reports",
        component: Reports,
        children: [
            { path: "/", redirect: "cash-management" },
            { path: "cash-management", component: CashManagementReport },
            { path: "customer", component: CustomerReport },

            { path: "inventory-adjustment", component: InventoryAdjustmentReport },
            { path: "inventory-transaction", component: InventoryTransactionReport },
            { path: "inventory-on-hand", component: InventoryOnHandReport },
            { path: "inventory-last-received", component: InventoryLastReceivedReport },
            { path: "room-movement", component: RoomMovementReport },
            { path: "transfer", component: InventoryTransferReport },
            { path: "purchase-order", component: PurchaseOrderReport },

            { path: "sale-report", component: SalesReport },
            { path: "sale-end-of-day", component: SalesReportEndOfDay },
            { path: "sale-by-employee", component: SalesReportByEmployee },
            { path: "sale-by-classification", component: SalesReportByClassification },
            { path: "sale-by-location", component: SalesReportByLocation },
            { path: "sale-by-product", component: SalesReportByProduct },

            // enhanced reports
            { path: "discount-report", component: DiscountReport },
            { path: "skipping-report", component: SkippingReport },
            { path: "drawer-action-report", component: DrawerActionReport },

            // gl account
            { path: "gl-account-totals", component: GLAccountTotalReport },
            { path: "gl-transactions", component: GLAccountTransactionReport },
        ],
    },
    { path: "/agco-logs/warehouses", component: AgcoLogWarehousePage },
    { path: "/agco-logs", component: AgcoLogPage },
    { path: "/devices", component: DevicePage },
    { path: "/pos-app-releases", component: PosAppReleasesPage },
    /**
     * RECONCILIATION
     */
    { path: "/reconciliations", component: ReconciliationPage },
    { path: "/reconciliations/new", component: ReconciliationCreatePage },
    { path: "/reconciliations/:id", component: ReconciliationDetailPage },
    { path: "/inventory-counts", component: InventoryCountsPage },
    { path: "/inventory-counts/new", component: InventoryCountCreatePage },
    { path: "/inventory-counts/:id", component: InventoryCountDetailPage },

    /**
     * PERMISSIONS
     */
    { path: "/permissions", component: PermissionPage },
    { path: "/permissions/editor", component: PermissionEditor },

    /**
     * SCANNER TEST
     */
    { path: "/scanner-test", component: ScannerTest, name: "scanner-test" },
]

export default routes
